import { DataApi } from "../../api";

const usehook = () => {
  const getAllTerms = async () => {
    try {
      const response = await DataApi.getTerms();
      return response.data;
    } catch (error) {}
  };
  return {
    getAllTerms,
  };
};

export default usehook;
